import { DateObject } from "react-multi-date-picker";
import { getDateFromDatePicker } from "../utils/datepicker";

export interface expenseCategory {
    key: number;
    id: number;
    code: string;
    name: string;
    icon?: string;
    color?: string;
    remark?: string;
    status: number;
    expenses_count?: number;
    total_amount?: number;
    create_date?: string;
}

export const initExpenseCategory: expenseCategory = {
    key: 0,
    id: 0,
    code: "",
    name: "",
    icon: "tags",
    color: "#FF7A59",
    remark: "",
    status: 1,
    expenses_count: 0,
    total_amount: 0,
    create_date: "",
};

export const DEFAULT_EXPENSE_CATEGORIES: expenseCategory[] = [
    { key: 1, id: 1, code: 'UTILITY', name: 'ค่าสาธารณูปโภค (ค่าน้ำ/ค่าไฟ/อินเทอร์เน็ต)', icon: 'bolt', color: '#F59E0B', remark: 'ค่าน้ำประปา, ค่าไฟฟ้า, ค่าบริการอินเทอร์เน็ตประจำร้าน', status: 1 },
    { key: 2, id: 2, code: 'RENT', name: 'ค่าเช่าและสถานที่', icon: 'store', color: '#6366F1', remark: 'ค่าเช่าพื้นที่ร้านค้า, ค่าส่วนกลางอาคาร', status: 1 },
    { key: 3, id: 3, code: 'SUPPLY', name: 'วัสดุสิ้นเปลืองและของใช้ในร้าน', icon: 'box-open', color: '#EC4899', remark: 'ถุงพลาสติก, ม้วนกระดาษความร้อนสลิป, น้ำยาทำความสะอาด', status: 1 },
    { key: 4, id: 4, code: 'SALARY', name: 'เงินเดือนและค่าจ้างแรงงาน', icon: 'users', color: '#10B981', remark: 'ค่าจ้างพนักงานพาร์ทไทม์, OT, ค่าเบี้ยเลี้ยงรายวัน', status: 1 },
    { key: 5, id: 5, code: 'SHIPPING', name: 'ค่าขนส่งและเดินทาง', icon: 'boxes-stacked', color: '#3B82F6', remark: 'ค่าส่งพัสดุสินค้า, ค่าน้ำมันรถรับส่งของ', status: 1 },
    { key: 6, id: 6, code: 'MAINTAIN', name: 'ค่าซ่อมแซมและบำรุงรักษา', icon: 'gear', color: '#8B5CF6', remark: 'ค่าล้างแอร์, ค่าซ่อมแซมอุปกรณ์ POS, ซ่อมบำรุงร้าน', status: 1 },
    { key: 7, id: 7, code: 'MARKETING', name: 'ค่าการตลาดและโฆษณา', icon: 'star', color: '#EF4444', remark: 'ค่าป้ายโฆษณา, ยิงแอด Facebook / TikTok, สื่อประชาสัมพันธ์', status: 1 },
    { key: 8, id: 8, code: 'OTHER', name: 'ค่าใช้จ่ายเบ็ดเตล็ดและอื่นๆ', icon: 'file-lines', color: '#64748B', remark: 'ค่าอาหารเครื่องดื่มพนักงาน, ค่าธรรมเนียมธนาคาร', status: 1 },
];

export interface expense {
    key: number;
    id: number;
    doc_no: string;              // e.g. EXP26080001
    expense_date: string;        // YYYY-MM-DD
    category_id: number;
    category_name?: string;
    title: string;               // ชื่อรายการค่าใช้จ่าย
    payee?: string;              // ผู้รับเงิน / ร้านค้าปลายทาง
    payment_type_id: number;     // 1 = เงินสด, 2 = เงินโอน, 3 = QR, 4 = บัตรเครดิต
    payment_type_name?: string;
    amount: number;              // จำนวนเงินก่อนภาษี (Subtotal)
    vat_type: number;            // 0 = ไม่มี VAT, 1 = รวม VAT 7%, 2 = แยก VAT 7%
    vat_amount: number;          // ภาษีมูลค่าเพิ่ม
    wht_type?: number;           // 0 = ไม่มี, 1 = หัก 1%, 2 = หัก 3%, 3 = หัก 5%
    wht_rate?: number;           // อัตราภาษีหัก ณ ที่จ่าย (%)
    wht_amount?: number;         // ภาษีหัก ณ ที่จ่าย (บาท)
    net_amount: number;          // ยอดจ่ายสุทธิ (Net Total)
    recorded_by?: string;        // ผู้บันทึกรายการ
    employee_id?: number;
    remark?: string;             // หมายเหตุ
    receipt_image?: string;      // ไฟล์รูปใบเสร็จแนบ
    status: number;              // 1 = ปกติ (อนุมัติ), 0 = ยกเลิก
    create_date?: string;
}

export const initExpense: expense = {
    key: 0,
    id: 0,
    doc_no: "",
    expense_date: getDateFromDatePicker(new DateObject()),
    category_id: 1,
    category_name: "ค่าสาธารณูปโภค (ค่าน้ำ/ค่าไฟ/อินเทอร์เน็ต)",
    title: "",
    payee: "",
    payment_type_id: 1,
    payment_type_name: "เงินสด (Cash)",
    amount: 0,
    vat_type: 0,
    vat_amount: 0,
    wht_type: 0,
    wht_rate: 0,
    wht_amount: 0,
    net_amount: 0,
    // Blank on purpose. This used to name a manager and claim employee
    // id 1, which pre-filled every new expense with an operator nobody
    // had chosen -- and, being truthy, prevented the form from ever
    // substituting the signed-in user.
    recorded_by: "",
    employee_id: 0,
    remark: "",
    receipt_image: "",
    status: 1,
    create_date: "",
};
